import client from '../client'
import {
  AuthUser,
  ResendEmailParams,
  EmailVerificationKey,
  VerifyEmailParams,
  ResetPasswordParams,
  DeregisterQuestion,
  DeregisterParams,
  RegisterParams,
} from './types'
import { ApiResponse } from '../types'

export * from './types'

export const login = async (
  email: string,
  password: string,
  remember: 0 | 1 = 1
) => {
  const { data }: ApiResponse<AuthUser> = await client.post(
    '/auth/user/login',
    {
      email,
      password,
      remember,
    }
  )
  return data
}

export const logout = async () => await client.delete('/auth/user/logout')

export const getUser = async () => {
  const { data }: ApiResponse<AuthUser> = await client.get('/auth/user')
  return data
}

export const register = async ({
  email,
  password,
  passwordConfirm,
  campaignCode,
  optIns,
  referralSubjectCode,
  socialSignupToken,
  utmSource,
  utmMedium,
  utmCampaign,
}: RegisterParams) => {
  const { data }: ApiResponse<AuthUser> = await client.post(
    '/auth/user/register',
    {
      email,
      password: password,
      password_confirmation: passwordConfirm,
      campaignCode,
      optIns,
      referralSubjectCode: referralSubjectCode ?? null,
      socialSignupToken: socialSignupToken ?? null,
      utmSource,
      utmMedium,
      utmCampaign,
    }
  )
  return data
}

export const resendEmail = async (params?: ResendEmailParams) => {
  return await client.post('/auth/user/email/resend', params)
}

export const verifyEmail = async (
  verificationKey: EmailVerificationKey,
  params: VerifyEmailParams
) => {
  return await client.get(`/auth/user/email/verify/${verificationKey}`, {
    params,
  })
}

export const passwordResetEmail = async (email: string) => {
  return await client.post(`/auth/user/password/email`, { email })
}

export const passwordReset = async (params: ResetPasswordParams) => {
  return await client.post(`/auth/user/password/reset`, {
    ...params,
    password_confirmation: params.passwordConfirmation,
  })
}

export const listDeregisterQuestions = async () => {
  const { data } = await client.get<DeregisterQuestion[]>(
    '/auth/user/deregister/questions'
  )
  return data
}

export const deregister = async (params: DeregisterParams) => {
  return await client.post('/auth/user/deregister', params)
}

export const directUserAuthForSocialLogin = async (
  userSocialAuthenticationId: string,
  params: {
    expires: number
    signature: string
  }
) => {
  return await client.get(
    `/user/direct_auth_for_social_login/${userSocialAuthenticationId}`,
    {
      params,
    }
  )
}
